import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { FlexboxColumn } from '../../components/action/Flexbox';
import UserNavigator from '../../components/UserNavigator/UserNavigator';
import MrepStateProvider from '../../helpers/mrepHelper';

const BenchProvider = () => {
  const location = useLocation();

  const NAVIGATOR_PATHS = ['/projects/', '/chains/' , '/takes/'];

  return (
    <MrepStateProvider>
      <FlexboxColumn alignItems='center' justifyContent='flex-start' gap='1rem' className='bench_wrapper'>
        {!NAVIGATOR_PATHS.some(path => location.pathname.includes(path)) && <UserNavigator />}
        <Outlet />
      </FlexboxColumn>
    </MrepStateProvider>
  );
};

export default BenchProvider;
